import router from '../router';
import tools from '@/util/tools';
import { Loading } from 'element-ui';

router.beforeEach((to, from, next) => {
  let loadingInstance = Loading.service();
  tools.isLogin(to, from, next, loadingInstance);
});